if (typeof VideoPopup !== 'function') {

  class VideoPopup extends HTMLElement {

    constructor() {
      super();
      this._bound = false;
    }

    connectedCallback() {
      if (this._bound) return;
      this._bound = true;

      // click open (zostaje jak było)
      var link = this.querySelector('[data-js-video-popup-link]');
      if (link) {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.open(false, true); // manual click => always play
        });
      }
    }

    // open + inject
    // auto=true => bez blackout
    // forcePlay=true => spróbuj od razu play
    open(auto, forcePlay) {
      if (auto === undefined) auto = false;
      if (forcePlay === undefined) forcePlay = false;

      // jeśli już mamy wideo/iframe w kontenerze, nie duplikuj
      if (this.querySelector('[data-js-video-popup-container] iframe, [data-js-video-popup-container] video')) {
        if (forcePlay) this.playMedia();
        return;
      }

      var blackout = null;

      if (!auto) {
        blackout = document.createElement('div');
        blackout.classList.add('video-popup__blackout');
        this.appendChild(blackout);
        setTimeout(function () { blackout.style.opacity = '1'; }, 10);

        this.classList.add('video-opened');

        var closeBtn = this.querySelector('[data-js-video-popup-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', () => {
            this.querySelectorAll('iframe, video').forEach(function (elm) { elm.remove(); });
            if (blackout) blackout.remove();
            this.classList.remove('video-opened');
          }, { once: true });
        }
      } else {
        this.classList.add('video-opened');
      }

      var tpl = this.querySelector('template');
      var container = this.querySelector('[data-js-video-popup-container]');
      if (!tpl || !container) return;

      // wyczyść stare
      container.querySelectorAll('iframe, video').forEach(function (elm) { elm.remove(); });

      var first = (tpl.content && tpl.content.firstElementChild) ? tpl.content.firstElementChild : null;
      if (!first) return;

      container.appendChild(first.cloneNode(true));

      if (forcePlay) {
        setTimeout(() => this.playMedia(), 50);
      }
    }

    playMedia() {
      var media = this.closest('[data-video]');
      if (!media) return;

      switch (media.dataset.productMediaType) {

        case 'video': {
          var v = media.querySelector('video');
          if (!v) return;
          v.muted = true;
          v.playsInline = true;
          v.setAttribute('muted', '');
          v.setAttribute('playsinline', '');
          v.setAttribute('autoplay', '');
          try {
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } catch (e) {}
          break;
        }

        case 'external_video-youtube': {
          var yt = media.querySelector('.js-youtube');
          if (yt && yt.contentWindow) {
            yt.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          }
          break;
        }

        case 'external_video-vimeo': {
          var vm = media.querySelector('.js-vimeo');
          if (vm && vm.contentWindow) {
            vm.contentWindow.postMessage('{"method":"play"}', '*');
          }
          break;
        }
      }
    }
  }

  if (typeof customElements.get('video-popup') === 'undefined') {
    customElements.define('video-popup', VideoPopup);
  }

  // DESKTOP: auto-inject (play może zadziałać od razu)
  function autoInjectOnLoad() {
    document.querySelectorAll('[data-js-product-gallery] video-popup').forEach(function (vp) {
      if (vp && typeof vp.open === 'function') {
        // inject bez blackout; próbuj play
        vp.open(true, true);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInjectOnLoad);
  } else {
    autoInjectOnLoad();
  }
  document.addEventListener('shopify:section:load', autoInjectOnLoad);

// MOBILE iOS: play musi być w tym samym call stacku co gesture
(function () {
  var fired = false;

  function unlockGesture() {
    if (fired) return;
    fired = true;

    // inject + play SYNCHRONICZNIE
    document.querySelectorAll('[data-js-product-gallery] video-popup').forEach(function (vp) {
      if (!vp) return;

      if (typeof vp.open === 'function') vp.open(true, false);
      if (typeof vp.playMedia === 'function') vp.playMedia();
    });

    // dodatkowy fallback: jeśli w DOM są już <video>, spróbuj też bezpośrednio
    document.querySelectorAll('[data-js-product-gallery] video').forEach(function (v) {
      v.muted = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      try {
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) {}
    });
  }

  document.addEventListener('touchstart', unlockGesture, { passive: true, once: true, capture: true });
  document.addEventListener('pointerdown', unlockGesture, { passive: true, once: true, capture: true });
})();

}

(function () {
  function kickVideos() {
    document.querySelectorAll('[data-js-product-gallery] video.product-media-video').forEach((v) => {
      v.muted = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      try {
        const p = v.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      } catch (e) {}
    });
  }

  // desktop: spróbuj od razu
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kickVideos);
  } else {
    kickVideos();
  }

  // iPhone: pierwsze dotknięcie = user gesture
  document.addEventListener('touchstart', kickVideos, { passive: true, once: true, capture: true });
})();